<template>
  <div class="sf-el heading-item">
    <div class="sf-heading">
      <h2 v-html="resolvedContent"></h2>
    </div>
  </div>
</template>

<script>
  import { toRef } from 'vue';
  import { useDynamicContent } from '@shared/composables/useDynamicContent';
  export default {
    name: 'HeadingElement',
    props: {
      content: String,
      parameters: {
        type: Array,
        default: () => [],
      },
    },
    setup(props) {
      const resolvedContent = useDynamicContent(toRef(props, 'content'), props.parameters);

      return {
        resolvedContent,
      };
    },
  };
</script>

<style scoped lang="scss">
  .sf-heading {
    color: var(--cs-text-heading);
    h1,
    h2,
    h3,
    h4 {
      color: inherit;
    }
  }
</style>
